import {
  createFileRoute,
  lazyRouteComponent,
  notFound,
} from "@tanstack/react-router";
import { IS_MIX_CATALOG } from "@/config/browserBoard";
import { parseBoardSlug } from "@/config/developmentBoardRuntime";

/**
 * /mix配下だけで有効な板slug付きスレッドページ。板mount(/b/{slug})では
 * 従来どおり未知パス扱いを維持する。総合カタログ対象への登録確認は
 * MixBoardThreadPage側で行い、未登録板は板ネイティブURLへ退避する。
 */
export const Route = createFileRoute("/$slug/thread/$threadId")({
  beforeLoad: ({ params }) => {
    if (
      !IS_MIX_CATALOG ||
      parseBoardSlug(`/b/${params.slug}`) !== params.slug
    ) {
      throw notFound();
    }
  },
  component: lazyRouteComponent(
    () => import("@/pages/ThreadPage"),
    "MixBoardThreadPage",
  ),
});
